import { Col, Form, Row } from "antd";
import React, { useEffect, useState } from "react";
import Inputs from "../../../../biblio/Inputs/Inputs";
import PrimaryButton from "../../../../biblio/Buttons/PrimaryButton";
import { DeleteOutlined, PlusCircleOutlined } from "@ant-design/icons";
import Selects from "../../../../biblio/Selects/Selects";

interface RequiredServicesInfoProps {
  form: any;
  korbaAssitances: any;
}

const RequiredServicesInfo = ({
  form,
  korbaAssitances,
}: RequiredServicesInfoProps) => {
  const [blocks, setBlocks] = useState<
    Array<{
      assistance_id: number;
      amount: number;
      description: string;
    }>
  >([
    {
      assistance_id: 0,
      amount: 0,
      description: "",
    },
  ]);

  const addBlock = () => {
    const newBlock = {
      assistance_id: 0,
      amount: 0,
      description: "",
    };
    setBlocks([...blocks, newBlock]);
  };

  useEffect(() => {
    const materialStateData = blocks.map((block, index) => ({
      assistance_id: block.assistance_id,
      amount: block.amount,
      description: block.description,
    }));
    form.setFieldValue("beneficiary_assistance_ids", materialStateData);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blocks]);

  const onChange = (
    value: any,
    key: "assistance_id" | "amount" | "description",
    index: number
  ) => {
    const l__bloks = [...blocks];
    if (key === "assistance_id") {
      l__bloks[index][key] = value.value;
    } else if (key === "amount") {
      l__bloks[index][key] = value as number;
    } else if (key === "description") {
      l__bloks[index][key] = value as string;
    }

    setBlocks(l__bloks);
  };

  const removeItem = (index: number) => {
    const updatedBlocks = [...blocks];
    updatedBlocks.splice(index, 1);
    const json: any = {};

    updatedBlocks.forEach((el: any, index: number) => {
      json["assistance_id" + index] =
        el.assistance_id !== 0 ? el.assistance_id : "";
      json["amount" + index] = el.amount;
      json["description" + index] = el.description;
    });

    form.resetFields();
    form.setFieldsValue(json);
    setBlocks(updatedBlocks);
  };
  return (
    <>
      <div className="takaful--title-tabs-sub">
        <span>الخدمات المطلوبة</span>
      </div>
      {blocks.map((block, index) => (
        <Row gutter={16} key={index}>
          <Col xxl={5} xl={5} lg={5} md={5} sm={20} xs={20}>
            <Form.Item
              name={`assistance_id${index}`}
              label="الخدمة"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{
                className: "takaful--label-style",
              }}
            >
              <Selects
                options={korbaAssitances}
                onChange={(e) => onChange(e, "assistance_id", index)}
              />
            </Form.Item>
          </Col>
          <Col xxl={5} xl={5} lg={5} md={5} sm={20} xs={20}>
            <Form.Item
              name={`amount${index}`}
              label="المبلغ"
              labelCol={{ className: "takaful--label-style" }}
            >
              <Inputs
                type="tel"
                onChange={(e) => onChange(e.target.value, "amount", index)}
              />
            </Form.Item>
          </Col>
          <Col xxl={5} xl={5} lg={5} md={5} sm={20} xs={20}>
            <Form.Item
              name={`description${index}`}
              label="وصف"
              labelCol={{ className: "takaful--label-style" }}
            >
              <Inputs
                type="text"
                onChange={(e) => onChange(e.target.value, "description", index)}
              />
            </Form.Item>
          </Col>

          <Col xxl={1} xl={1} lg={4} md={4} sm={4} xs={4}>
            {blocks.length > 1 && (
              <Form.Item
                name={`remove${index}`}
                label=" "
                labelCol={{ className: "takaful--label-style" }}
              >
                <PrimaryButton
                  title=""
                  icon={<DeleteOutlined />}
                  onClick={() => removeItem(index)}
                />
              </Form.Item>
            )}
          </Col>
        </Row>
      ))}

      <Col
        className="takaful--button-material"
        xxl={2}
        xl={2}
        lg={4}
        md={4}
        sm={24}
        xs={24}
      >
        <PrimaryButton
          title="إضافة بند"
          icon={<PlusCircleOutlined />}
          onClick={() => addBlock()}
          className="takaful--primary-button-info"
        />
      </Col>
    </>
  );
};

export default RequiredServicesInfo;
